import React from 'react';
import PropTypes from 'prop-types';
import { Visible } from "../../helpers/Authorization";

export default function PageActions({ actions }) {
  return actions.map((action, index) => {
    const Icon = action.icon ? action.icon : null;
    const Component = action.component;

    return (
      <Visible key={`Visible_${index}`} when={action.canPerform()}>
        <Component key={`PageAction_${index}`} {...action.props} data-testid={action.props.name}>
          <Icon />
          {action.text}
        </Component>
      </Visible>
    );
  });
}

PageActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.func.isRequired,
      props: PropTypes.object.isRequired,
      icon: PropTypes.object,
      text: PropTypes.string
    })
  )
};
